import { render } from "./ApeConstructorTraitCard.vue?vue&type=template&id=5d799a2c"
import script from "./ApeConstructorTraitCard.vue?vue&type=script&lang=js"
export * from "./ApeConstructorTraitCard.vue?vue&type=script&lang=js"

import "./ApeConstructorTraitCard.vue?vue&type=style&index=0&id=5d799a2c&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__